import { put, takeLatest } from 'redux-saga/effects';
import { Notify } from '@flexisaf/flexibull2';
import { TOP_RIGHT, SUCCESS } from 'utils/constants';
import request from 'utils/request';
import urls from 'utils/config';
import { addBankAccountSuccess, addBankAccountFailure } from '../actions';
import internationalPaymentConfigTypes from '../types';
import { networkErrorHandler } from 'utils/errrorHandlers';

const { API_BASE_URL } = urls || {};

function* addBankAccount({ payload: { data, cb } }) {
  const url = `${API_BASE_URL}/stripe`;
  const response = yield request({
    method: 'post',
    data: data,
    url,
  });

  if (response.success) {
    yield put(addBankAccountSuccess());
    Notify(`Bank account added successfully`, {
      position: TOP_RIGHT,
      status: SUCCESS,
    });
    cb();
  } else {
    yield put(addBankAccountFailure('An error occured. Please reload the page to try again.'));
    networkErrorHandler(response?.statusCode, response?.message?.string || response?.message);
  }
}

export function* onAddBankAccount() {
  yield takeLatest(
    internationalPaymentConfigTypes.ADD_BANK_ACCOUNT_REQUEST,
    addBankAccount
  );
}
